import { useEffect } from "react";
import { AxiosError } from "axios";
import useAudienceSizeApiService from "../../features/tags/services/api/AudienceSizeApiService";
import useSegmentAssignmentPreviewApiService from "../../features/odp-management/services/api/SegmentAssignmentPreviewApiService";
import { TargetingType } from "../model/Segment";

type UseAudienceCountResult = {
  audienceCount: number;
  isLoadingCount: boolean;
  isError: boolean;
  error: AxiosError | null;
};

const useAudienceCount = (
  targetingType: TargetingType,
  tagIds: number[],
  segmentIds: number[]
): UseAudienceCountResult => {
  const tagAudienceQuery = useAudienceSizeApiService(tagIds);

  const {
    mutate: fetchSegmentPreview,
    data: segmentData,
    isLoading: segmentAudienceLoading,
    isError: segmentIsError,
    error: segmentError,
  } = useSegmentAssignmentPreviewApiService();

  useEffect(() => {
    if (targetingType === "segments" && segmentIds.length > 0) {
      fetchSegmentPreview({ segment_ids: segmentIds });
    }
  }, [targetingType, JSON.stringify(segmentIds), fetchSegmentPreview]);

  const segmentAudienceCount =
    segmentIds.length === 0
      ? 0
      : segmentData?.total_matched_employee_count ?? 0;

  const audienceCount =
    targetingType === "segments"
      ? segmentAudienceCount
      : tagAudienceQuery.data?.audience_size ?? 0;

  const isLoadingCount =
    targetingType === "segments"
      ? segmentAudienceLoading
      : tagAudienceQuery.isLoading;

  const isError =
    targetingType === "segments" ? segmentIsError : tagAudienceQuery.isError;

  const error =
    targetingType === "segments" ? segmentError : tagAudienceQuery.error;

  return { audienceCount, isLoadingCount, isError, error };
};

export default useAudienceCount;
